type PrescriberIdReader = () => string | undefined | null

let readFromStore: PrescriberIdReader | null = null

export const registerPrescriberIdSource = (reader: PrescriberIdReader): void => {
  readFromStore = reader
}

export const resetPrescriberIdSource = (): void => {
  readFromStore = null
}

export const readPrescriberIdFromStorage = (): string => {
  try {
    const raw = localStorage.getItem('prescriber')
    if (!raw || raw === 'undefined' || raw === 'null') return ''
    const parsed = JSON.parse(raw)
    const id = parsed?.id
    return typeof id === 'string' ? id : ''
  } catch {
    return ''
  }
}

export const resolvePrescriberId = (): string => {
  const fromStore = readFromStore?.()
  if (typeof fromStore === 'string' && fromStore.length > 0) {
    return fromStore
  }
  return readPrescriberIdFromStorage()
}
